import * as React from "react";

import ConfirmInventory from "../../../components/ShopOwner/InventoryV2/ConfirmInventory";
import SalesScreen from "../../../components/ShopOwner/InventoryV2/SalesScreen";
import SettlementScreen from "../../../components/ShopOwner/InventoryV2/SettlementScreen";

type View = "confirm" | "sales" | "settlement";

interface InventoryV2PageProps {
  // which screen to open on - the sidebar's Sales entry routes straight to "sales"
  initialView?: View;
}

// Entry point for the redesigned inventory management module. Confirm is the
// main screen; the Sales tab swaps in the calendar / day-detail flow and the
// Settlement tab swaps in the settlement screen. Activate opens as a popup from
// within each screen.
const InventoryV2Page: React.FC<InventoryV2PageProps> = ({ initialView = "confirm" }) => {
  const [view, setView] = React.useState<View>(initialView);

  if (view === "sales") {
    return <SalesScreen onGoConfirm={() => setView("confirm")} onGoSettlement={() => setView("settlement")} />;
  }
  if (view === "settlement") {
    return <SettlementScreen onGoConfirm={() => setView("confirm")} onGoSales={() => setView("sales")} />;
  }
  return <ConfirmInventory onGoSales={() => setView("sales")} onGoSettlement={() => setView("settlement")} />;
};

export default InventoryV2Page;
